// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"49dd4bcf","453":"7c66ee22"}[chunkId] + ".chunk.js";
};